import React from "react";

const VerifyPhone = (props) => (
    <svg
        width={200}
        height={114}
        viewBox="0 0 200 114"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <rect width={200} height={113.733} rx={30} fill="#F0F3F6" />
        <g opacity={0.4} clipPath="url(#clip0_2927_33594)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.871 31.457L27.3086 29.9895C28.8319 29.9895 30.079 31.2366 30.079 32.7599C30.079 36.2248 30.6316 39.5515 31.6583 42.6579C31.9645 43.6286 31.7405 44.7077 30.9639 45.4843L25.841 50.5353C29.8324 58.3798 37.0748 64.1248 44.9193 68.146L48.499 62.8286C49.0516 62.3021 49.7461 62.0258 50.4667 62.0258C50.743 62.0258 51.0491 62.052 51.3254 62.164C54.4318 63.1907 57.7847 63.7433 61.2234 63.7433C62.7467 63.7433 63.9938 64.9904 63.9938 66.5137V78.5798C63.9938 80.1032 62.7467 81.3502 61.2234 81.3502C35.1959 81.354 14.1006 60.2587 14.1006 34.2274C14.1006 32.7041 15.3476 31.457 16.871 31.457Z"
                fill="#A1BACA"
            />
        </g>
        <path
            d="M170.598 70.0767C170.208 69.6839 169.572 69.6827 169.181 70.0742L159.486 79.7694C159.096 80.1594 158.464 80.16 158.073 79.7708L155.12 76.8297C154.73 76.4405 154.098 76.4411 153.708 76.8311L152.743 77.7955C152.353 78.186 152.353 78.8192 152.743 79.2097L158.073 84.5394C158.463 84.9299 159.097 84.9299 159.487 84.5394L171.563 72.4633C171.953 72.0738 171.954 71.4425 171.566 71.0516L170.598 70.0767Z"
            fill="#FEFEFE"
        />
        <rect
            x={75.9307}
            y={37.9653}
            width={53.5043}
            height={13.867}
            rx={4}
            fill="#9DB5C6"
        />
        <rect
            opacity={0.4}
            x={75.9307}
            y={61.9223}
            width={39.7554}
            height={13.867}
            rx={4}
            fill="#9DB5C6"
        />
        <g opacity={0.9}>
            <rect
                x={141.716}
                y={55.0619}
                width={40.4638}
                height={40.4638}
                rx={20.2319}
                fill="#3EC28F"
            />
        </g>
        <g opacity={0.3}>
            <rect
                x={136.552}
                y={50.5073}
                width={50.9824}
                height={49.8976}
                rx={24.9488}
                fill="#3EC28F"
            />
        </g>
        <path
            d="M173.57 80.3066C173.442 80.5998 173.153 80.7892 172.833 80.7895C172.722 80.7898 172.612 80.7668 172.511 80.7219C172.104 80.544 171.918 80.07 172.096 79.6628C173.32 76.8446 173.242 73.6303 171.884 70.874C170.526 68.1178 168.025 66.0979 165.044 65.3508C162.063 64.6039 158.905 65.2055 156.408 66.9956L157.993 67.2467C158.408 67.3116 158.703 67.6848 158.671 68.1038C158.638 68.5228 158.289 68.846 157.869 68.8463C157.826 68.8463 157.784 68.8429 157.741 68.8365L154.415 68.3089C154.387 68.3002 154.36 68.2901 154.333 68.2783C154.278 68.2654 154.224 68.2466 154.173 68.2219C154.124 68.1961 154.078 68.1655 154.036 68.1302C154.015 68.1136 153.996 68.0959 153.978 68.0771C153.963 68.0625 153.958 68.0418 153.944 68.0255H153.944C153.908 67.9831 153.877 67.9365 153.852 67.8871C153.825 67.8456 153.802 67.8016 153.785 67.7553C153.77 67.7064 153.761 67.6562 153.756 67.6057C153.75 67.5521 153.75 67.4982 153.756 67.4446V67.4334V67.3834L154.283 64.0572C154.353 63.6183 154.766 63.3189 155.205 63.3888C155.644 63.4584 155.943 63.8709 155.873 64.31L155.679 65.5394C157.839 64.0586 160.423 63.3208 163.04 63.4376C165.657 63.5543 168.164 64.5194 170.185 66.1868C172.204 67.8543 173.628 70.1335 174.238 72.6807C174.849 75.2279 174.614 77.9048 173.57 80.3072L173.57 80.3066ZM171.257 83.3449C171.252 83.2941 171.243 83.2438 171.228 83.195C171.213 83.1493 171.192 83.1049 171.167 83.0631C171.142 83.0137 171.111 82.9674 171.076 82.9248C171.061 82.9088 171.056 82.8877 171.042 82.8731L171.042 82.8734C171.019 82.8563 170.994 82.8406 170.969 82.8266C170.927 82.7912 170.881 82.7606 170.833 82.7348C170.784 82.7107 170.732 82.6919 170.68 82.6787C170.653 82.6666 170.625 82.6565 170.598 82.6481L167.271 82.1202C166.832 82.0509 166.42 82.3506 166.351 82.7895C166.281 83.2287 166.581 83.6407 167.02 83.7099L168.605 83.9611C166.108 85.7509 162.95 86.3519 159.97 85.6053C156.99 84.8583 154.489 82.8389 153.131 80.0832C151.772 77.3272 151.694 74.1135 152.918 71.2951C153.011 71.0984 153.02 70.8722 152.944 70.6682C152.868 70.4645 152.712 70.3003 152.512 70.213C152.313 70.1261 152.087 70.1235 151.885 70.206C151.684 70.2885 151.524 70.4493 151.444 70.6514C150.397 73.0546 150.162 75.7331 150.773 78.2814C151.384 80.8303 152.808 83.1111 154.83 84.7789C156.852 86.4466 159.362 87.4109 161.981 87.5256C164.599 87.6404 167.184 86.8995 169.344 85.4153L169.149 86.6447H169.15C169.116 86.8554 169.168 87.071 169.294 87.2435C169.419 87.4161 169.608 87.532 169.819 87.5651C169.861 87.573 169.903 87.5766 169.946 87.5764C170.341 87.5758 170.678 87.2879 170.739 86.8973L171.267 83.571V83.5211V83.5065V83.5068C171.27 83.4529 171.266 83.399 171.258 83.3457L171.257 83.3449Z"
            fill="white"
        />
        <defs>
            <clipPath id="clip0_2927_33594">
                <rect
                    width={49.8969}
                    height={49.8969}
                    fill="white"
                    transform="translate(14.1006 31.457)"
                />
            </clipPath>
        </defs>
    </svg>
);

export default VerifyPhone;
